export const navigateToNewExistingVerification = () => {
    window.history.replaceState(
        {},
        'Zocdoc - Booking',
        '#newExistingVerification'
    );
};

export const clearNewExistingVerification = () => {
    window.history.pushState(
        {},
        'Zocdoc - Booking',
        window.location.pathname + window.location.search
    );
};
